// src/context/LikesContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';
import API from '../api/client';
import { AuthContext } from './AuthContext';

export const LikesContext = createContext();

export const LikesProvider = ({ children }) => {
  // Estado para guardar el estado de likes por petId.
  const [likes, setLikes] = useState({});
  // Estado adicional para almacenar la lista de mascotas favoritas.
  const [favorites, setFavorites] = useState([]);

  // Extraemos isAuthenticated del AuthContext para sincronizar el estado de likes.
  const { isAuthenticated } = useContext(AuthContext);

  // Cuando el usuario se desloguea, reiniciamos likes y favorites.
  React.useEffect(() => {
    if (!isAuthenticated) {
      setLikes({});
      setFavorites([]);
    }
  }, [isAuthenticated]);

  /**
   * Función para actualizar el estado de like para una mascota.
   * @param {number} petId - ID de la mascota.
   * @param {object} newState - Nuevo estado ({ liked, likeCount }).
   */
  const updateLike = (petId, newState) => {
    setLikes(prev => ({
      ...prev,
      [petId]: newState
    }));
  };

  /**
   * Función para cargar las mascotas favoritas del usuario desde el backend.
   * Ahora acepta un objeto con latitud/longitud opcional:
   *   loadFavorites({ lat, lng })
   * Si no se pasa, llama sin esos parámetros.
   */
  const loadFavorites = useCallback(async ({ lat, lng } = {}) => {
    try {
      // Preparamos los params solo si tenemos coordenadas
      const params = {};
      if (lat != null && lng != null) {
        params.lat = lat;
        params.lng = lng;
      }

      // Llamada al endpoint con params en querystring
      const response = await API.get('/favorites/', {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });

      setFavorites(response.data);
      console.log('[LikesContext] Favorites cargados:', response.data);
    } catch (error) {
      console.error('[LikesContext] Error cargando favorites:', error);
    }
  }, []); // no dependencias dinámicas

  return (
    <LikesContext.Provider value={{ likes, updateLike, favorites, loadFavorites }}>
      {children}
    </LikesContext.Provider>
  );
};
